import React from "react";
import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { NJIM } from "../../theme/njimTheme";

type Tone = {
  color: string;
  bg: string;
  labelKey: string;
};

const TONES: Record<string, Tone> = {
  paid: { color: NJIM.success, bg: NJIM.successWash, labelKey: "status.paid" },
  success: { color: NJIM.success, bg: NJIM.successWash, labelKey: "status.paid" },
  approved: { color: NJIM.success, bg: NJIM.successWash, labelKey: "status.approved" },
  delivered: { color: NJIM.success, bg: NJIM.successWash, labelKey: "status.delivered" },
  completed: { color: NJIM.success, bg: NJIM.successWash, labelKey: "status.completed" },
  confirmed: { color: NJIM.success, bg: NJIM.successWash, labelKey: "status.confirmed" },
  pending: { color: NJIM.warning, bg: NJIM.warningWash, labelKey: "status.pending" },
  pendingreview: { color: NJIM.warning, bg: NJIM.warningWash, labelKey: "codSalesRep.pendingReview" },
  "pending-review": { color: NJIM.warning, bg: NJIM.warningWash, labelKey: "codSalesRep.pendingReview" },
  pendingapproval: { color: NJIM.warning, bg: NJIM.warningWash, labelKey: "codSalesRep.pendingApproval" },
  partlypaid: { color: NJIM.warning, bg: NJIM.warningWash, labelKey: "codSalesRep.partlyPaid" },
  "partly-paid": { color: NJIM.warning, bg: NJIM.warningWash, labelKey: "codSalesRep.partlyPaid" },
  postedtosage: { color: NJIM.success, bg: NJIM.successWash, labelKey: "codSalesRep.postedToSage" },
  "posted-to-sage": { color: NJIM.success, bg: NJIM.successWash, labelKey: "codSalesRep.postedToSage" },
  pendingsagesync: { color: NJIM.warning, bg: NJIM.warningWash, labelKey: "codSalesRep.pendingSageSync" },
  partial: { color: NJIM.warning, bg: NJIM.warningWash, labelKey: "ui.partial" },
  initiated: { color: NJIM.warning, bg: NJIM.warningWash, labelKey: "status.initiated" },
  shipped: { color: NJIM.info, bg: NJIM.mintWash, labelKey: "status.shipped" },
  "in-transit": { color: NJIM.info, bg: NJIM.mintWash, labelKey: "ui.inTransit" },
  intransit: { color: NJIM.info, bg: NJIM.mintWash, labelKey: "ui.inTransit" },
  rejected: { color: NJIM.danger, bg: NJIM.dangerWash, labelKey: "status.rejected" },
  failed: { color: NJIM.danger, bg: NJIM.dangerWash, labelKey: "status.failed" },
  overdue: { color: NJIM.danger, bg: NJIM.dangerWash, labelKey: "status.overdue" },
  cancelled: { color: NJIM.textSecondary, bg: NJIM.muted, labelKey: "ui.cancelled" },
  canceled: { color: NJIM.textSecondary, bg: NJIM.muted, labelKey: "ui.cancelled" },
  draft: { color: NJIM.textSecondary, bg: NJIM.muted, labelKey: "ui.draft" },
  notdelivered: { color: NJIM.textSecondary, bg: NJIM.muted, labelKey: "status.notdelivered" },
};

function normalizeStatus(status: string): string {
  return String(status ?? "")
    .trim()
    .toLowerCase()
    .replace(/[\s_]+/g, "-");
}

interface StatusChipProps {
  status: string;
  label?: string;
}

const StatusChip: React.FC<StatusChipProps> = ({ status, label }) => {
  const { t } = useTranslation();
  const key = normalizeStatus(status);
  const compact = key.replace(/-/g, "");
  const tone = TONES[key] ?? TONES[compact];

  const display = label
    ? label
    : tone
      ? t(tone.labelKey)
      : status;

  return (
    <Chip
      size="small"
      label={display}
      sx={{
        height: 26,
        fontWeight: 600,
        fontSize: 12,
        color: tone?.color ?? NJIM.textSecondary,
        bgcolor: tone?.bg ?? NJIM.muted,
        border: `1px solid ${tone?.color ?? NJIM.border}`,
      }}
    />
  );
};

export default StatusChip;
